  export const formatPhoneNumber = (phoneStr: string) => {
    if (!phoneStr) return "";
    const clean = phoneStr.replace(/\D/g, "");
    if (clean.length === 10) {
      return `${clean.slice(0, 4)} ${clean.slice(4, 7)} ${clean.slice(7)}`;
    }
    return phoneStr;
  };